/*
 * Animacje wejścia i parallaks (assets/custom-animacje.css).
 *
 * Wejście w kadr: IntersectionObserver zamiast nasłuchu na scroll — element
 * dostaje klasę raz i obserwator go puszcza, więc przewijanie nic nie kosztuje.
 *
 * Parallaks liczymy w jednej pętli rAF dla wszystkich kadrów naraz; przesuw
 * jest niewielki (±6% wysokości kadru), bo większy przy szybkim scrollu
 * odsłania krawędzie zdjęcia.
 */
(function () {
  if (window.__animacjeStrony) return;
  window.__animacjeStrony = true;

  var spokojnie = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wejscia() {
    var elementy = document.querySelectorAll('.anim:not(.jest-widoczny)');
    if (!elementy.length) return;

    if (spokojnie || !('IntersectionObserver' in window)) {
      for (var i = 0; i < elementy.length; i++) elementy[i].classList.add('jest-widoczny');
      return;
    }

    var obserwator = new IntersectionObserver(
      function (wpisy) {
        for (var i = 0; i < wpisy.length; i++) {
          if (!wpisy[i].isIntersecting) continue;
          wpisy[i].target.classList.add('jest-widoczny');
          obserwator.unobserve(wpisy[i].target);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    for (var j = 0; j < elementy.length; j++) obserwator.observe(elementy[j]);
  }

  function parallaks() {
    var kadry = document.querySelectorAll('.parallaks');
    if (!kadry.length || spokojnie) return;

    var czeka = false;
    function przelicz() {
      var wysokoscOkna = window.innerHeight || 0;
      for (var i = 0; i < kadry.length; i++) {
        var r = kadry[i].getBoundingClientRect();
        if (r.bottom < -200 || r.top > wysokoscOkna + 200) continue;
        // -1 (kadr nad ekranem) … 1 (pod ekranem)
        var srodek = (r.top + r.height / 2 - wysokoscOkna / 2) / (wysokoscOkna / 2 + r.height / 2);
        kadry[i].style.setProperty('--przesuw', Math.round(srodek * r.height * 0.06) + 'px');
      }
    }

    function naZdarzenie() {
      if (czeka) return;
      czeka = true;
      window.requestAnimationFrame(function () {
        czeka = false;
        przelicz();
      });
    }

    window.addEventListener('scroll', naZdarzenie, { passive: true });
    window.addEventListener('resize', naZdarzenie);
    przelicz();
  }

  /*
   * Kształt kafla w markizie bierzemy z proporcji samego zdjęcia — Liquid nie
   * zna wymiarów plików z `assets/`, a crop „na siłę" psuł pionowe kadry.
   */
  function ksztaltyKadrow() {
    var zdjecia = document.querySelectorAll('img[data-ksztalt]');
    for (var i = 0; i < zdjecia.length; i++) {
      (function (img) {
        function oznacz() {
          if (!img.naturalWidth) return;
          var kadr = img.closest('.galeria__kadr');
          if (!kadr) return;
          kadr.classList.add(img.naturalWidth >= img.naturalHeight ? 'jest-poziom' : 'jest-pion');
        }
        if (img.complete) oznacz();
        else img.addEventListener('load', oznacz, { once: true });
      })(zdjecia[i]);
    }
  }

  /*
   * Ekrany makiet (Nowa odsłona): zrzut strony jest ciężki i ładowany leniwie,
   * więc bez tego wskakiwał na czarny ekran w połowie swojego przewijania.
   * Do wczytania obraz jest niewidoczny, a jego animacja stoi w miejscu;
   * po `load` wyświetlacz dostaje klasę i „włącza się" płynnie od góry.
   */
  function ekrany() {
    var zrzuty = document.querySelectorAll('img[data-ekran]');
    for (var i = 0; i < zrzuty.length; i++) {
      (function (img) {
        function wlacz() {
          if (!img.naturalWidth) return;
          var ekran = img.closest('[data-ekran-ramka]') || img.parentElement;
          if (ekran) ekran.classList.add('jest-wlaczony');
        }
        if (img.complete) wlacz();
        else img.addEventListener('load', wlacz, { once: true });
      })(zrzuty[i]);
    }
  }

  function start() {
    wejscia();
    parallaks();
    ksztaltyKadrow();
    ekrany();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Edytor motywu podmienia sekcje w locie — nowe elementy też mają się pokazać
  document.addEventListener('shopify:section:load', start);
})();
